import { CustomAccountSelect } from "../.."

/**
 * @name CustomAccountWithAddButtonSelect
 * @function
 * @extends React.Component
 * @description A wrapper component for showing a "CustomAccountSelect" component with an "Add Account" button.
 * This add account button is for adding an unlinked account through a modal.
 * @example
    { hasFromAddAccountButton 
    && <CustomAccountWithAddButtonSelect accounts={ accounts } />
    }
    { !hasFromAddAccountButton 
    && <CustomAccountSelect accounts={ accounts } />
    }
 */
export default function CustomAccountWithAddButtonSelect(props) {
    return (
        <CustomAccountSelect { ...props } hasAddButton={ true }/>
    );
}